webpackJsonp([29],{

/***/ 1219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _ConvertPdfToWordLandingPageFullWidthUploadPanel = __webpack_require__(1363);

var _ConvertPdfToWordLandingPageFullWidthUploadPanel2 = _interopRequireDefault(_ConvertPdfToWordLandingPageFullWidthUploadPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConvertPdfToWordLandingPage = function ConvertPdfToWordLandingPage() {
  (0, _react.useEffect)(function () {
    window.Upload.activateUploadButtonById('uploadPDFLarge');
  }, []);

  return _react2.default.createElement(
    'div',
    {
      className: '\n        convert-pdf-to-word-container\n        large-upload-panel-mock-freewrite-wrapper\n        large-upload-panel-wrapper'
    },
    _react2.default.createElement('img', {
      src: '/images/convert-pdf-to-word-no-buttons-toolbar-web.png',
      alt: 'Mock Free Write Background',
      className: 'large-upload-panel-mock-freewrite-bg-img img-lg'
    }),
    _react2.default.createElement('img', {
      src: '/images/convert-pdf-to-word-no-buttons-toolbar-mobile.png',
      alt: 'Mock Free Write Background',
      className: 'large-upload-panel-mock-freewrite-bg-img img-xs'
    }),
    _react2.default.createElement(_ConvertPdfToWordLandingPageFullWidthUploadPanel2.default, null)
  );
};

var ConvertPdfToWordLandingPageWithInit = (0, _WithInit2.default)(ConvertPdfToWordLandingPage);

exports.default = ConvertPdfToWordLandingPageWithInit;

/***/ }),

/***/ 1315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ConvertPdfToWordLandingPage = __webpack_require__(1219);

var _ConvertPdfToWordLandingPage2 = _interopRequireDefault(_ConvertPdfToWordLandingPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.ConvertPdfToWordLandingPage = _ConvertPdfToWordLandingPage2.default;

/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LandingPageFullWidthUploadPanelCTA = __webpack_require__(442);

var _LandingPageFullWidthUploadPanelCTA2 = _interopRequireDefault(_LandingPageFullWidthUploadPanelCTA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConvertPdfToWordLandingPageFullWidthUploadPanel = function ConvertPdfToWordLandingPageFullWidthUploadPanel() {
  return _react2.default.createElement(
    'div',
    { className: 'large-upload-panel-upload-section-wrapper' },
    _react2.default.createElement(
      'div',
      { className: 'upload-wrap edit-pages-upload-wrap hide-for-photos' },
      _react2.default.createElement(
        'form',
        { id: 'dropzoneUploader', className: 'uploader' },
        _react2.default.createElement(
          'div',
          { className: 'alert alert-error uploader-error' },
          'Error'
        ),
        _react2.default.createElement(
          'div',
          { className: 'uploader-area edit-pages-uploader-area' },
          _react2.default.createElement('img', {
            src: '/images/icon-pdf-to-doc-v2.png',
            alt: 'Document and Arrow Icon',
            className: 'large-upload-panel-pdf-to-word-icon'
          }),
          _react2.default.createElement(
            'h3',
            { className: 'large-upload-panel-header' },
            'Convert Your PDF to a Word Doc'
          ),
          _react2.default.createElement(
            'p',
            { className: 'large-upload-panel-sub-header' },
            'And ',
            _react2.default.createElement(
              'strong',
              null,
              'edit text'
            ),
            ' just like you would on a Word document.'
          ),
          _react2.default.createElement(_LandingPageFullWidthUploadPanelCTA2.default, {
            ctaId: 'uploadPDFLarge',
            ctaText: 'Upload a PDF to Convert'
          })
        )
      )
    )
  );
};

exports.default = ConvertPdfToWordLandingPageFullWidthUploadPanel;

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Buttons = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandingPageFullWidthUploadPanelCTA = function LandingPageFullWidthUploadPanelCTA(props) {
  return _react2.default.createElement(
    'div',
    {
      className: 'large-upload-panel-cta-wrapper',
      id: props.ctaId,
      onClick: props.ctaOnClick
    },
    _react2.default.createElement(
      _Buttons.PrimaryButton,
      { className: 'large-upload-panel-cta-button', onClick: function onClick() {} },
      props.ctaText
    )
  );
};

LandingPageFullWidthUploadPanelCTA.defaultProps = {
  ctaOnClick: function ctaOnClick() {},
  ctaText: ''
};

LandingPageFullWidthUploadPanelCTA.propTypes = {
  ctaId: _propTypes2.default.string.isRequired,
  ctaOnClick: _propTypes2.default.func,
  ctaText: _propTypes2.default.string
};

exports.default = LandingPageFullWidthUploadPanelCTA;

/***/ })

},[1315]);


// WEBPACK FOOTER //
// convert-pdf-to-word-landing-page.js